var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 254.98 254.98",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#2969B3;}\r\n\t.st2{fill:#222653;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n\t.st4{fill:#CDEAE8;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8.1379,8.1379;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.74,47.81c6.61-12.62,15.3-29.5,15.3-29.5s0.17-8.28,0.34-18.3h-20.3c0.08,0.64,0.16,1.27,0.23,1.87 C217.64,12.83,219.58,30.32,220.74,47.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.61,127.3c0,0,24.69-0.88,40.01-1.57c-0.93,0.04-1.88,0.09-2.86,0.13c-18.59,0.75-39.91,1.77-40.13,0 s-8.03-44.65-9.17-51.99c-1.15-7.34-6.42-28.2-5.96-8.71c0.46,19.49,0.69,38.06,0.69,38.06l-0.92,16.74c0,0-0.58,0.26-1.62,0.69 c-0.92,41.98-2.96,85.41-2.74,104.79c0.16,13.37,0.85,22.75,1.65,29.54h34.92l-5-45.75C155.48,209.23,146.61,135.25,146.61,127.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.27,121.59c-2-0.56-3.51-1.12-4.36-1.63C51.51,106.75,49.37,35.22,52.79,0H42.02 c-2.49,12.09-4.44,23.96-4.86,31.91c-0.61,11.31-0.61,14.68,4.28,20.79c3.52,7.04,6.73,19.57,2.75,21.1 c-3.97,1.53-6.11-7.18-9.02-8.87c-2.9-1.68-4.28-1.38-3.82,6.27c0.46,7.64-1.7,17.73-0.09,19.57s13.54,14.68,15.07,18.04 c1.53,3.36-1.38,1.68-6.27-1.22c-4.89-2.9-14.83-6.88-18.19-14.83s-7.95-14.68-8.25-24.92C13.41,60.86,14.19,26.05,15.2,0H0 v254.98h69.26C65.21,215.88,56.1,127.91,56.27,121.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.09,71.96L226.7,98.37c0.29,7.01,0.26,14.13-0.07,21.58c-1.25,0.33-2.46,0.63-3.65,0.92 c-0.83,12.68-5.74,90.03-5.44,95.38c0.17,3.02-1.04,21.12-2.17,38.72h39.61V57.89L252.09,71.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.16,73.23c0.45,2.79,0.85,5.56,1.19,8.32c1.29-2.42,2.24-4.29,2.59-5.16 C229.34,72.89,227.53,69.14,224.16,73.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.36,125.16c1.12-0.09,2.36-0.25,3.67-0.45c-4.16,0.43-8.65,0.75-13.8,1 C191.87,125.49,195.58,125.3,197.36,125.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.91,119.96c0.84,0.51,2.36,1.07,4.36,1.63c0-0.01,0-0.02,0-0.03c0,0,44.25,11.92,70.39-1.61 c-0.01,0.23-0.01,0.46-0.02,0.69c1.04-0.42,1.62-0.69,1.62-0.69l0.92-16.74c0,0-0.23-18.57-0.69-38.06 c-0.46-19.49,4.82,1.38,5.96,8.71c1.15,7.34,8.94,50.22,9.17,51.99s21.54,0.75,40.13,0c0.98-0.04,1.92-0.08,2.86-0.13 c0.2-0.01,0.41-0.02,0.61-0.03c5.15-0.25,9.64-0.57,13.8-1c7.65-1.18,17.83-3.96,22.01-4.75c-0.02,0.25-0.04,0.57-0.06,0.92 c1.2-0.29,2.41-0.6,3.65-0.92c0.32-7.45,0.35-14.57,0.07-21.58l-12.37,12.87c0,0-6.27,1.22-3.67-3.36 c2.01-3.54,10.31-18.12,14.69-26.33c-0.34-2.76-0.73-5.53-1.19-8.32c-0.31,0.38-0.63,0.81-0.96,1.32 c-3.97,6.11-10.7,18.8-11.01,19.41c-0.31,0.61-2.14,2.29-2.14,2.29s-2.9,0.61-2.29-2.29c0.61-2.9,2.9-27.82,6.11-33.33 c1.04-1.78,3.72-6.83,6.87-12.84c-1.16-17.49-3.1-34.98-4.42-45.94c-0.07-0.6-0.15-1.23-0.23-1.87H52.79 C49.37,35.22,51.51,106.75,51.91,119.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M220.74,47.81c-3.15,6.02-5.83,11.06-6.87,12.84c-3.21,5.5-5.5,30.42-6.11,33.33 c-0.61,2.9,2.29,2.29,2.29,2.29s1.83-1.68,2.14-2.29c0.31-0.61,7.03-13.3,11.01-19.41c0.33-0.51,0.65-0.95,0.96-1.32 c3.37-4.1,5.18-0.34,3.78,3.16c-0.35,0.87-1.3,2.74-2.59,5.16c-4.38,8.21-12.68,22.79-14.69,26.33c-2.6,4.59,3.67,3.36,3.67,3.36 l12.37-12.87l25.39-26.42l2.89-14.07V0h-18.6c-0.18,10.02-0.34,18.3-0.34,18.3S227.35,35.19,220.74,47.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.62,67.83c0.31,10.24,4.89,16.97,8.25,24.92s13.3,11.92,18.19,14.83c4.89,2.9,7.8,4.59,6.27,1.22 c-1.53-3.36-13.45-16.2-15.07-18.04s0.55-11.92,0.09-19.57c-0.46-7.64,0.92-7.95,3.82-6.27c2.9,1.68,5.04,10.4,9.02,8.87 c3.97-1.53,0.77-14.06-2.75-21.1c-4.89-6.11-4.89-9.48-4.28-20.79c0.43-7.95,2.37-19.82,4.86-31.91H15.2 C14.19,26.05,13.41,60.86,13.62,67.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.65,120.65c0.01-0.23,0.01-0.46,0.02-0.69c-26.14,13.53-70.39,1.61-70.39,1.61c0,0.01,0,0.02,0,0.03 c-0.17,6.32,8.94,94.29,12.99,133.39h56.3c-0.79-6.79-1.49-16.17-1.65-29.54C123.68,206.05,125.72,162.62,126.65,120.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217.54,216.26c-0.3-5.35,4.61-82.71,5.44-95.38c0.02-0.36,0.04-0.67,0.06-0.92 c-4.18,0.78-14.36,3.57-22.01,4.75c-1.31,0.2-2.55,0.36-3.67,0.45c-1.78,0.14-5.49,0.33-10.13,0.55c-0.2,0.01-0.41,0.02-0.61,0.03 c-15.32,0.69-40.01,1.57-40.01,1.57c0,7.95,8.87,81.94,8.87,81.94l5,45.75h54.89C216.5,237.38,217.71,219.28,217.54,216.26z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.63,149.99c0,0,20.11,26.53,67.16,2.13"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage5);
export default __webpack_public_path__ + "static/media/image5.40595f930570fa9ab36a181231db8b5a.svg";
export { ForwardRef as ReactComponent };